import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import * as Yup from 'yup';
import { PaymentModeFormValue } from 'src/models/PaymentMode.model';
import PaymentMode from '../Layouts/PaymentModeForm';
import { useGetPaymentModeByIdQuery, useUpdatePaymentModeByIdMutation } from 'src/services/PaymentModeService';
import { showToast } from 'src/utils/showToaster';
import { CircularProgress } from '@mui/material';

type Props = {
  onClose: () => void;
  selectedPaymentModeId: string
};

const EditPaymentModeWrapper = ({ onClose, selectedPaymentModeId }: Props) => {
  // Form Initial Values
  const [items, setItems] = useState<any>({});

  const { isLoading, isFetching, data } =
    useGetPaymentModeByIdQuery(selectedPaymentModeId);
  const [updatePaymentModeById] = useUpdatePaymentModeByIdMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setItems(data?.data);
    }
  }, [isLoading, isFetching, data]);
  const initialValues: PaymentModeFormValue = {
    type: items?.type || '',
    name: items?.name || '',
    value: items?.value || ''
  };
  // Validation Schema
  const validationSchema = Yup.object().shape({
    type: Yup.string().required('Please select payment type'),

    name: Yup.string().when('type', (type: any, schema) => {
      if (type === 'PHYSICAL' || type === 'VIRTUAL') {
        return schema.required('Please enter payment mode name');
      }
      return schema;
    }),

    value: Yup.string().when('type', (type: any, schema) => {
      if (type === 'PHYSICAL') {
        return schema.required('Please enter value');
      }
      return schema.notRequired();
    }),
  });

  // Handle Submit
  const handleSubmit = (
    values: PaymentModeFormValue,
    { setSubmitting, resetForm }: FormikHelpers<PaymentModeFormValue>
  ) => {
    let payload: any = {
      type: values.type,
      name: values.name,
    };

    if (values.type === 'PHYSICAL') {
      payload.value = values.value;
    }
    updatePaymentModeById({ id: selectedPaymentModeId, body: payload }).then(
      (res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            resetForm();
            onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      }
    );
  };


  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <PaymentMode formikProps={formikProps} onClose={onClose} formType='EDIT' />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditPaymentModeWrapper;